import { AutogenLayoutExciseTaxControl } from "./autogen/AutogenLayoutExciseTaxControl";
import { LookupModelSearchEvent } from "@mcleod/components";

export class ExciseTaxControl extends AutogenLayoutExciseTaxControl {
    onLoad(): void | Promise<void> {
        this.sourceExcisetaxRate.orderBy = [{ field: "effective_date", sort: "desc" }, { field: "excisetax_code_id", sort: "asc" }];
        this.sourceExcisetaxCode.orderBy = [{ field: "id", sort: "asc" }];
    }

    textboxStateIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.country_id = "in CAN,CAD"; // show only Canadian provinces
    }

    textboxExcisetaxCodeIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }
}

